import { supabase } from './supabase';

export const scrapingService = {
  fetchProductData: async (url: string) =>
    supabase.functions.invoke('product', {
      body: { url },
    }),

  fetchCategoryData: async (url: string) => {
    return await supabase.functions.invoke('category', {
      body: { url },
    });
  },
};
